import React from "react";
import SmBannerImage from "../../images/salesmate-main-banner-image.png";
import SmBannerIconAutomation from "../../images/Automation.svg";
import SmBannerIconCall from "../../images/Call.svg";
import SmBannerIconEmails from "../../images/Emails.svg";
import SmBannerIconReport from "../../images/Report.svg";
import SmBannerIconSupport from "../../images/Support.svg";
import SmBannerIconTasks from "../../images/Tasks.svg";
import { Link } from "gatsby";
import { motion } from 'framer-motion';

export default function SalesmateMainBanner() {
  const variants = {
    hidden: {
      opacity: 0,
      scale: 0.5
    },
    show: {
      opacity: 1,
      scale: 1,
      delayChildren: 0.2,
      staggerChildren: 0.2,
    }
  };

  const icons = [
    {
      icon: SmBannerIconAutomation,
      name: "Automation"
    }, {
      icon: SmBannerIconSupport,
      name: "Suppport"
    }, {
      icon: SmBannerIconCall,
      name: "Call"
    }, {
      icon: SmBannerIconReport,
      name: "Report"
    }, {
      icon: SmBannerIconTasks,
      name: "Tasks"
    }, {
      icon: SmBannerIconEmails,
      name: "Emails"
    },
  ];
  return (
    <div className="cs-page-main-banner-section section-gap sm-cs-main-banner">
      <div className="cs-banner-image d-flex align-end justify-center">
        <motion.div initial="hidden" animate="show" variants={variants} className="container d-flex flex-wrap align-start justify-center">
          <img src={SmBannerImage} title="Salesmate CRM Dashboard" alt="crm dashboard" />
          <div className="mobile-icons">
            {
              icons.map((icon, i) => <motion.div variants={variants} key={i}>
                <img src={icon.icon} title="Automation" alt="Automation" />
                <span>{icon.name}</span>
              </motion.div>)
            }
          </div>
        </motion.div>
      </div>
      <div className="cs-main-banner-detail">
        <div className="container">
          <div className="row d-flex flex-wrap row-banner-title">
            <div className="col left-bar">
              <h1>Automating Sales</h1>
            </div>
            <div className="col right-bar">
              <h3>How we built a sales operating system <br />from ground up?</h3>
            </div>
          </div>
          <div className="row d-flex flex-wrap align-v-center">
            <div className="col left-bar">
              <p>Strategy · DevOps · Engineering · Innovation</p>
            </div>
            <div className="col right-bar">
              {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}